import StorageIcon from '@material-ui/icons/Storage';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const repositoryMapPage = PageBlueprint.make({
  params: {
    path: '/mapa-repositorios',
    routeRef: rootRouteRef,
    loader: () =>
      import('./RepositoryMapPage').then(module => (
        <module.RepositoryMapPage />
      )),
  },
});

export const repositoryMapPlugin = createFrontendPlugin({
  pluginId: 'repository-map',
  title: 'Mapa de Repositórios',
  icon: <StorageIcon />,
  routes: { root: rootRouteRef },
  extensions: [repositoryMapPage],
});
